const getCurrentCardBrand = ({ brandState }) => brandState.currentBrand;

const getBrands = ({ brandState }) => brandState.brands;

export { getCurrentCardBrand, getBrands };
